import React, { useState } from 'react';
import Selection from 'src/components/Selection/Selection';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    MainMarketColumn, MainMarketColumnWrapper,
    MainMarketsColumnTitle
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MainMarkets/MainMarkets.style';
import { QuickPickViewState, sortSelections } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { useAsObservableSource } from 'mobx-react-lite';
import { TypeId } from 'src_common/common/websocket2/type';

class SimpleSelectionState {

    public constructor(private readonly props: SimpleSelectionPropsType) {
    }

    public onHoverSelection = (): void => {
        this.props.onHoverSelectionHandler(this.props.eventId, this.props.selection.id);
    };
}

interface SimpleSelectionPropsType {
    selection: SelectionModel,
    eventId: number,
    userId: number,
    onHoverSelectionHandler: (eventId: number, selectionId: number) => void
}

const SimpleSelection = observer('SimpleSelection', (propsIn: SimpleSelectionPropsType) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new SimpleSelectionState(props));
    if (props.selection === null) {
        return null;
    }
    const key = props.selection.id;

    return (
        <Selection
            key={`${key}-shown`}
            className='main-market-column__selection'
            userId={props.userId}
            marketId={props.selection.marketId}
            selectionId={props.selection.id}
            allowShowSp={true}
            onHoverSelection={state.onHoverSelection}
        />
    );
});

interface MainMarketColumnPropsType {
    eventId: number,
    userId: number,
    marketId: TypeId.MarketId,
    quickPickState: QuickPickViewState,
}

export const MainMarketsColumn = observer('MainMarketsColumn', (props: MainMarketColumnPropsType) => {
    const appState = useAppStateContext();
    const market = appState.websocketV2.getMarket(props.marketId);

    if (market === null || market.active === false) {
        return null;
    }

    return (
        <MainMarketColumn>
            <MainMarketsColumnTitle>
                {market.name}
            </MainMarketsColumnTitle>
            <MainMarketColumnWrapper>
                {
                    sortSelections(market.selections, props.quickPickState.sort).map(selection => (
                        <SimpleSelection key={selection.id}
                            selection={selection}
                            userId={props.userId}
                            eventId={props.eventId}
                            onHoverSelectionHandler={props.quickPickState.onHoverSelectionHandler} />)
                    )
                }
            </MainMarketColumnWrapper>
        </MainMarketColumn>
    );
});
